import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";

const ModalCajaEntrada = ({ estado, onCloseModal, item, onReturnValue, isnew }) => {
  const hoy = new Date().toISOString().split("T")[0];

  const [formData, setFormData] = useState({
    idcajaentrada: "",
    articulo: "",
    cantidad: "",
    fecha: hoy,
    proveedor: "",
    observacion: "",
  });

  useEffect(() => {
    if (item) {
      setFormData({
        idcajaentrada: item.idcajaentrada || "",
        articulo: item.articulo || "",
        cantidad: item.cantidad || "",
        fecha: item.fecha ? item.fecha.split("T")[0] : hoy,
        proveedor: item.proveedor || "",
        observacion: item.observacion || "",
      });
    } else {
      setFormData({ idcajaentrada: "", articulo: "", cantidad: "", fecha: hoy, proveedor: "", observacion: "" });
    }
  }, [item]);

  const set = (field) => (e) => setFormData({ ...formData, [field]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    const upper = Object.fromEntries(
      Object.entries(formData).map(([k, v]) => [k, typeof v === "string" ? v.toUpperCase() : v])
    );
    onReturnValue({ ...upper, fecha: formData.fecha }, isnew);
  };

  return (
    <Modal show={estado} onHide={onCloseModal} centered>
      <Modal.Header closeButton>
        <Modal.Title>{isnew ? "Agregar Entrada" : "Editar Entrada"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit} id="formCajaEntrada">
          <div className="form-group mb-3">
            <label className="form-label">Artículo <span className="text-danger">*</span></label>
            <input
              type="text"
              className="form-control"
              required
              value={formData.articulo}
              onChange={set("articulo")}
              placeholder="Nombre del artículo"
            />
          </div>
          <div className="row">
            <div className="col-6 form-group mb-3">
              <label className="form-label">Cantidad <span className="text-danger">*</span></label>
              <input
                type="number"
                className="form-control"
                required
                min="1"
                value={formData.cantidad}
                onChange={set("cantidad")}
              />
            </div>
            <div className="col-6 form-group mb-3">
              <label className="form-label">Fecha <span className="text-danger">*</span></label>
              <input
                type="date"
                className="form-control"
                required
                value={formData.fecha}
                onChange={set("fecha")}
              />
            </div>
          </div>
          <div className="form-group mb-3">
            <label className="form-label">Proveedor</label>
            <input
              type="text"
              className="form-control"
              value={formData.proveedor}
              onChange={set("proveedor")}
              placeholder="Nombre del proveedor"
            />
          </div>
          <div className="form-group mb-3">
            <label className="form-label">Observación</label>
            <textarea
              className="form-control"
              rows={2}
              style={{ resize: "none" }}
              value={formData.observacion}
              onChange={set("observacion")}
              placeholder="Detalle adicional..."
            />
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={onCloseModal}>Cancelar</Button>
        <Button type="submit" form="formCajaEntrada" variant="primary">Guardar</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalCajaEntrada;
